import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import config from '../../config/config';
import TicketAnswerForm from './TicketAnswerForm';

function TicketDetailsModal({
                                show,
                                onHide,
                                ticket,
                                getTicketTypeLabel,
                                getTicketStatusLabel,
                                getKubuniAnswer,
                                token
                            }) {
    const [showFullScreen, setShowFullScreen] = useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    const [ticketAnswers, setTicketAnswers] = useState(ticket.answers || []);

    const toggleFullScreen = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setShowFullScreen(!showFullScreen);
    };

    const closeFullScreen = () => {
        setShowFullScreen(false);
        setSelectedImageUrl(null);
    };

    const getTicketImageUrl = (ticket) => {
        return `${config.ktickUrl}documents/${ticket.reference}/${ticket.imageFilename}`;
    };

    const getAnswerImageUrl = (answer) => {
        return `${config.documentsUrl}answers/${answer.uuid}.${answer.imageExtension}`;
    };

    const getCreatorLabel = (createdByLabel) => {
        return createdByLabel === 'KUM' ? 'Kubuni' : ticket.website;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const handleAnswerPosted = (newAnswer) => {
        setTicketAnswers([...ticketAnswers, newAnswer]);
    };

    const isPdfAttachment = (filename) => {
        return filename?.toLowerCase().endsWith('.pdf');
    };

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="xl"
                aria-labelledby="ticket-details-modal"
                style={{ fontFamily: 'Arial, sans-serif' }}
            >
                <Modal.Header
                    closeButton
                    style={{
                        backgroundColor: '#dee2e6',
                        borderBottom: '1px solid #adb5bd',
                        padding: '10px 20px',
                    }}
                >
                    <Modal.Title id="ticket-details-modal" style={{ fontSize: '20px' }}>
                        Demande n°{ticket.id} - {getTicketTypeLabel(ticket.ticketType)}
                        <span
                            style={{
                                fontSize: '16px',
                                backgroundColor: '#343a40',
                                color: 'white',
                                padding: '5px 15px',
                                borderRadius: '12px',
                                marginLeft: '10px',
                            }}
                        >
                            {getTicketStatusLabel(ticket.status)}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Header
                    style={{
                        backgroundColor: '#ced4da',
                        padding: '10px 20px',
                        textAlign: 'center',
                    }}
                >
                    <Modal.Title style={{ fontSize: '18px', width: '100%' }}>
                        {ticket.subject}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{
                        padding: '20px',
                        maxHeight: '70vh',
                        overflowY: 'auto',
                        backgroundColor: '#f8f9fa',
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <div
                            style={{
                                padding: '15px',
                                borderRadius: '8px',
                                backgroundColor: '#e9ecef',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            }}
                        >
                            <h5 style={{ fontSize: '16px', marginBottom: '10px' }}>Descriptif</h5>
                            <p style={{ margin: 0, lineHeight: '1.6' }}>{ticket.description}</p>
                            {ticket.hasImage && ticket.imageFilename && (
                                <div style={{ marginTop: '15px' }}>
                                    {!isPdfAttachment(ticket.imageFilename) && (
                                        <img
                                            src={getTicketImageUrl(ticket)}
                                            alt="Pièce jointe"
                                            style={{
                                                width: '100px',
                                                height: '100px',
                                                objectFit: 'cover',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                marginBottom: '10px',
                                            }}
                                            onClick={() => toggleFullScreen(getTicketImageUrl(ticket))}
                                        />
                                    )}
                                    <div>
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                if (isPdfAttachment(ticket.imageFilename)) {
                                                    window.open(getTicketImageUrl(ticket), '_blank');
                                                } else {
                                                    toggleFullScreen(getTicketImageUrl(ticket));
                                                }
                                            }}
                                        >
                                            Voir pièce jointe
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div
                            style={{
                                padding: '15px',
                                borderRadius: '8px',
                                backgroundColor: '#e9ecef',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            }}
                        >
                            <h5 style={{ fontSize: '16px', marginBottom: '10px' }}>Message Kubuni</h5>
                            <p style={{ margin: 0, lineHeight: '1.6' }}>{getKubuniAnswer(ticket)}</p>
                        </div>

                        {ticketAnswers && ticketAnswers.length > 0 && (
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#e9ecef',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <h5 style={{ fontSize: '16px', marginBottom: '10px' }}>Réponses</h5>
                                {ticketAnswers.map((answer, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            marginBottom: '15px',
                                            paddingLeft: '10px',
                                            borderLeft: '3px solid #007bff',
                                        }}
                                    >
                                        <p style={{ margin: 0, lineHeight: '1.6' }}>
                                            <strong>
                                                {getCreatorLabel(answer.createdByLabel)} (
                                                {formatDate(answer.createdAt)}) :
                                            </strong>{' '}
                                            {answer.content}
                                        </p>
                                        {answer.hasImage && (
                                            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <img
                                                    src={getAnswerImageUrl(answer)}
                                                    alt="Image de la réponse"
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => toggleFullScreen(getAnswerImageUrl(answer))}
                                                />
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => toggleFullScreen(getAnswerImageUrl(answer))}
                                                    style={{
                                                        borderColor: '#007bff',
                                                        color: '#007bff',
                                                        padding: '5px 10px',
                                                        borderRadius: '4px',
                                                    }}
                                                >
                                                    Voir l'image
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        <TicketAnswerForm
                            ticketId={ticket.id}
                            apiUrl={config.apiUrl}
                            token={token}
                            onAnswerPosted={handleAnswerPosted}
                            buttonClassName="btn btn-primary"
                        />

                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                            <Button
                                className="btn btn-primary"
                                onClick={onHide}
                            >
                                Fermer
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {showFullScreen && selectedImageUrl && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(0,0,0,0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 100000,
                    }}
                    onClick={closeFullScreen}
                >
                    <button
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '20px',
                            background: '#fff',
                            border: 'none',
                            borderRadius: '50%',
                            width: '30px',
                            height: '30px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                        onClick={closeFullScreen}
                    >
                        ✕
                    </button>
                    <img
                        src={selectedImageUrl}
                        alt="Image en plein écran"
                        style={{
                            maxWidth: '90%',
                            maxHeight: '90%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                        }}
                    />
                </div>
            )}
        </>
    );
}

export default TicketDetailsModal;